export default {
    list: {
        title: "Containers",
        subtitle: "Manage your shipping containers",
        newContainer: "New Container",
        viewMap: "View Map",
        loading: "Loading containers...",
        clearFilters: "Clear Filters",
        backToDashboard: "Back to Dashboard",
        filters: {
            searchPlaceholder: "Search by container number, route...",
            statusPlaceholder: "Filter by status",
            riskLevelPlaceholder: "Filter by risk level",
            documentStatusPlaceholder: "Filter by document status",
            shippingCompanyPlaceholder: "Filter by shipping company",
            commodityPlaceholder: "Filter by commodity",
            originPlaceholder: "Filter by origin",
            portPlaceholder: "Filter by arrival port",
            allStatuses: "All statuses",
            allLevels: "All levels",
            allCompanies: "All companies",
            allCommodities: "All commodities",
            allOrigins: "All origins",
            allPorts: "All ports",
        },
        table: {
            title: "Containers",
            description: "Complete list of containers",
            updating: "Updating...",
            headers: {
                containerNumber: "Container Number",
                route: "Route",
                progress: "Progress",
                status: "Status",
                documentStatus: "Documents",
                riskLevel: "Risk",
                value: "Value",
                createdAt: "Created",
                actions: "Actions",
            },
            view: "View",
            edit: "Edit",
            delete: "Delete",
            noContainers: {
                title: "No containers found",
                message: "Try modifying the search filters",
                emptyMessage: "Start by creating your first container",
                createFirst: "Create the first container",
            },
        },
        charts: {
            riskLevels: "Risk Levels Distribution",
            containerStatus: "Container Status Distribution",
            documentStatus: "Document Status Distribution",
        },
    },
    form: {
        title: "New Container",
        editTitle: "Edit Container",
        subtitle: "Create a new shipping container",
        editSubtitle: "Edit container details",
        loading: "Loading container...",
        back: "Back",
        sections: {
            containerInfo: "Container Information",
            route: "Route",
            order: "Order",
            receiver: "Receiver",
            value: "Value",
        },
        fields: {
            containerNumber: "Container Number",
            containerNumberPlaceholder: "TCLU1234567",
            status: "Status",
            statusPlaceholder: "Select status",
            routeFrom: "From",
            routeFromPlaceholder: "New York, USA",
            routeTo: "To",
            routeToPlaceholder: "London, UK",
            eta: "ETA",
            shippingCompany: "Shipping Company",
            shippingCompanyPlaceholder: "Select company",
            receiver: "Receiver",
            receiverPlaceholder: "Select receiver",
            amount: "Amount",
            amountPlaceholder: "125000",
            currency: "Currency",
            currencyPlaceholder: "Select currency",
            orderId: "Order ID",
            orderIdPlaceholder: "Enter or select Order ID",
            orderIdSelectExisting: "Select from existing orders",
            orderIdEnterManually: "Enter manually",
        },
        actions: {
            cancel: "Cancel",
            save: "Save Changes",
            create: "Create Container",
        },
        errors: {
            generic: "An error occurred while saving the container",
            allFieldsRequired: "All fields are required",
            amountInvalid: "Amount must be a number greater than 0",
            containerExists: "A container with this number already exists",
        },
        noReceivers: "No active receivers available. Invite a new receiver to continue.",
        selectReceiver: "Select Receiver",
        notesOptional: "Notes (optional)",
        notesPlaceholder: "Add a note for the receiver...",
        selectedReceiver: "Selected Receiver",
        name: "Name",
        email: "Email",
        country: "Country",
        sendInvite: "Send Invite",
    },
    detail: {
        back: "Back to Containers",
        backToList: "Back to list",
        loading: "Loading container details...",
        notFound: {
            title: "Container not found",
            message: "The requested container does not exist or you do not have permission to view it.",
        },
        actions: {
            uploadDocuments: "Upload Documents",
            triage: "Triage",
            edit: "Edit",
            share: "Share",
            delete: "Delete",
        },
        confirmDeleteContainer: {
            title: "Delete Container",
            message: "Are you sure you want to delete container {{containerNumber}}? This action cannot be undone.",
            cancel: "Cancel",
            delete: "Delete",
        },
        tabs: {
            overview: "Overview",
            info: "Information",
            documents: "Documents",
            timeline: "Timeline",
        },
        info: {
            containerInfo: "Container Information",
            route: "Route",
            shipper: "Shipper",
            receiver: "Receiver",
            from: "From",
            to: "To",
            created: "Created",
            expandMap: "Expand map",
            collapseMap: "Collapse map",
            fields: {
                status: "Status",
                progress: "Progress",
                riskLevel: "Risk Level",
                documentStatus: "Document Status",
                eta: "ETA",
                value: "Value",
                shippingCompany: "Shipping Company",
                country: "Country",
            },
        },
        documents: {
            title: "Documents",
            headers: {
                name: "Name",
                type: "Type",
                status: "Status",
                uploaded: "Uploaded",
                actions: "Actions",
            },
            actions: {
                view: "View",
                review: "Review",
                history: "History",
                download: "Download",
                delete: "Delete",
            },
            confirmDelete: {
                title: "Delete Document",
                message: "Are you sure you want to delete this document? This action cannot be undone.",
                cancel: "Cancel",
                delete: "Delete",
            },
            uploadInDevelopment: "Document upload functionality under development",
            uploadDocument: "Upload Document",
            discrepancies: {
                allCongruent: {
                    title: "All documents are consistent",
                    message: "Discrepancies have been resolved successfully. All attributes extracted from documents are now aligned and verified.",
                    resetButton: "Reset discrepancies",
                    viewTriage: "View Triage",
                },
                detected: {
                    title: "Possible discrepancies in document data",
                    message:
                        "We detected inconsistencies between some attributes extracted from this container's documents. We recommend proceeding with triage to verify and correct them.",
                    goToTriage: "Go to Document Triage",
                },
            },
        },
        timeline: {
            title: "Timeline Events",
            events: {
                containerCreated: "Container created",
                statusChanged: "Status changed",
                documentsUploaded: "Documents uploaded",
                progressUpdated: "Progress updated",
            },
            statusChangedFrom: "Status changed from",
            to: "to",
            documentsUploadedCount: "documents uploaded",
            progressUpdatedTo: "Progress updated to",
        },
    },
    triage: {
        title: "Document Triage",
        subtitle: "Container",
        resolveWithAI: "Resolve with AI",
        tabs: {
            matrix: "Matrix",
            visual: "Visual",
            raw: "Raw Data",
        },
        matrix: {
            attribute: "Attribute",
            ok: "OK",
            ko: "KO",
        },
        visual: {
            document: "Document",
            check: "Check",
            ok: "OK",
        },
        raw: {
            json: "JSON",
            highlightDiscrepancies: "Highlight discrepancies",
        },
        modal: {
            title: "Resolving discrepancies with AI",
            analyzing: "Analyzing and correcting extracted attributes…",
            completed: "Resolution completed",
            allResolved: "All discrepancies have been resolved. You can close this window to see the updated results.",
            close: "Close",
        },
    },
    upload: {
        title: "Upload Documents",
        subtitle: "Upload documents for container",
        loading: "Loading...",
        notFound: {
            title: "Container not found",
            message: "The requested container does not exist.",
            backToList: "Back to list",
        },
        fileTooLarge: "File {fileName} is too large. Maximum 10MB allowed.",
        selectAtLeastOne: "Select at least one file to upload",
        documentType: "Document Type",
        uploadSelected: "Upload Selected",
        cancel: "Cancel",
        confirmUpload: "Confirm Upload",
        uploadInProgress: "Upload in progress",
        uploadCompleted: "Upload completed",
        returnToDocuments: "Return to Documents",
        removeFile: "Remove file",
        selectFiles: "Select Files",
        selectedFiles: "Selected Files",
        file: "file",
        files: "files",
        document: "document",
        documents: "documents",
        container: "Container",
        uploading: "Uploading...",
        uploadedSuccessfully: "Uploaded successfully",
        documentsUploadedSuccess: "Documents uploaded successfully!",
        documentsNowAvailable: "document(s) have been uploaded and are now available in the Documents section.",
        goToDocuments: "Go to Documents",
        confirmUploadTitle: "Confirm Document Upload",
        unknownTypeWarning: 'Some documents have type "Unknown Document". This means the system was unable to automatically identify the document type.',
        unknownTypeDocuments: "Documents with Unknown type:",
        proceedAnyway: "You can still proceed with the upload. Documents can be classified manually later.",
        proceedWithUpload: "Proceed with Upload",
    },
    worldMap: {
        title: "World Routes Map",
        backToList: "Back to list",
        updateInfo: "The system checks and updates container positions periodically.",
        lastUpdate: "Last update",
        containerDetails: "Container Details",
        viewFullDetails: "View full details",
        showContainers: "Show Containers",
        containerList: "Containers on Map",
        containerSingular: "container",
        containerPlural: "containers",
    },
    receiver: {
        title: "Received Containers",
        subtitle: "Manage containers received from shippers",
        loading: "Loading containers...",
        searchPlaceholder: "Search by container ID, route or shipper...",
        shipperPlaceholder: "Filter by shipper",
        allShippers: "All shippers",
        description: "Complete list of received containers",
        headers: {
            containerId: "Container ID",
            shipper: "Shipper",
            route: "Route",
            shippingCompany: "Shipping Company",
            progress: "Progress",
            eta: "ETA",
            status: "Status",
            docStatus: "Doc Status",
            riskLevel: "Risk Level",
            value: "Value",
            actions: "Actions",
        },
        noContainers: {
            title: "No containers found",
            message: "Try modifying the search filters",
            emptyMessage: "No containers received yet",
        },
        viewDetails: "View Details",
        shipper: "Shipper",
    },
};
